export default __webpack_public_path__ + "static/media/img-0621-monaco-premium-face.724348fd.png";